import React from 'react'
import Button from '@mui/material/Button'

const EditPolicy = ({ buttonText, setShowEditorWithData }) => {
    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'end',
                marginTop: '10px',
                marginBottom: '10px',
            }}
        >
            <Button
                style={{ cursor: 'pointer' }}
                variant="contained"
                sx={{ marginRight: 2 }}
                onClick={() => setShowEditorWithData(true)}
            >
                {buttonText}
            </Button>
        </div>
    )
}

export default EditPolicy
